import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AppBar,
  Box,
  Container,
  IconButton,
  Typography,
  useTheme,
  Paper,
  styled,
} from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

// Imágenes (deberás importarlas o convertirlas a formato web)
import RunnerWoman from "../../../../assets/images/RunnerWoman_2.png";
import StartBadges from "../../../../assets/images/StartBadges.png";
import FinishBadges from "../../../../assets/images/FinishBadges_2.png";
import Loading from "../../../../components/Loading/Loading";
import { handleError } from "../../../../utils/handleError";
import toast from "react-hot-toast";
import {
  getAllBadgesAPI,
  getBadgeAssignedAPI,
  getHistoryBadgesAPI,
} from "../../../../services/rest/badges/badgesService";
import ModalBadgeOfUser from "./CardBadge";
import ModalUnlockBadge from "./CardUnlockBadge";
import ModalNextToTheApp from "../../../../components/Dashboard/ModalNextToTheApp/ModalNextToTheApp";
import { clearBadge, setBadge } from "../../../../redux/slice/badgeSlice";

const StyledCard = styled(Paper)(({ theme, blocked }) => ({
  width: 80,
  height: 80,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.background.paper,
  position: "relative",
  border: "1px solid",
  borderRadius: "50%",
  margin: theme.spacing(0, 1),
  boxShadow: theme.shadows[4],
  borderColor: blocked ? theme.palette.warning.main : theme.palette.grey[500],
  transform: "rotateX(35deg) rotateY(10deg)",
  perspective: 150,
  cursor: "pointer",
  "&:hover": {
    transform: "rotateX(35deg) rotateY(10deg) scale(1.05)",
  },
}));

const BadgeScreen = () => {
  const theme = useTheme();
  const { planName } = useSelector((state) => state.membershipReducer);
  const { _id } = useSelector((state) => state.userReducer);
  const [showModal, setShowModal] = useState(false);
  const [selectedBadge, setSelectedBadge] = useState({});
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listUnlokBades, setListUnlokBadges] = useState([]);
  const [badgeUnlock, setBadgeUnlock] = useState(false);
  const [open, setOpne] = useState(true);
  const dispatch = useDispatch();

  // Dividir los logros en grupos de 3 (cada grupo es una fila)
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  const groupedAchievements = chunkArray(achievements, 3);

  const getAllBadges = async () => {
    try {
      const historyBadges = await getHistoryBadgesAPI(_id);
      const badgeAssigned = await getBadgeAssignedAPI(_id);
      setListUnlokBadges(badgeAssigned?.newBadges ?? []);
      if (badgeAssigned?.newBadges?.length > 0) {
        const { newBadges } = badgeAssigned;

        const badgeData =
          newBadges.length === 1
            ? newBadges[0]
            : newBadges[newBadges.length - 1];

        dispatch(
          setBadge({
            _id: badgeData?.badgeId ?? 0,
            nameBadge: badgeData?.badgeName ?? "Explorador Inicial",
            description: "",
            iconURL: "",
            type: "",
            goalValue: "",
            membreshipReq: "",
          })
        );
      } else {
        if (historyBadges?.length > 0) {
          const lastBadge = historyBadges[historyBadges.length - 1];
          dispatch(
            setBadge({
              _id: lastBadge?.badgeId ?? 0,
              nameBadge: lastBadge?.badgeName ?? "Explorador Inicial",
              description: "",
              iconURL: "",
              type: "",
              goalValue: "",
              membreshipReq: "",
            })
          );
        } else {
          dispatch(clearBadge());
        }
      }

      const badges = await getAllBadgesAPI();

      // Si hay logros nuevos desbloqeados se manda el modal
      badgeAssigned?.newBadges.length + 1 > 0 && setBadgeUnlock(true);
      const newBadges = badges.filter(
        (badge) => badge?.membershipReq === planName
      );

      if (newBadges.length === 0) {
        toast.error(
          `No se encontraron Insignias.\n Su membresía no cuenta con insignias.`
        );
      }
      // Filtramos lo logros desbloqueados
      const listBadges = [];
      newBadges.forEach((badge) => {
        let unlocked = false;
        historyBadges.forEach((badgeAssign) => {
          if (badge?._id === badgeAssign?.badgeId) {
            listBadges.push({ ...badge, blocked: true });
            unlocked = true;
          }
        });
        !unlocked && listBadges.push({ ...badge, blocked: false });
      });

      setAchievements(listBadges);
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      console.log("error", error);

      setLoading(false);
      toast.error(`Algo salió mal. \n ${message ?? "Intentelo más tarde."} `);
    }
  };

  useEffect(() => {
    getAllBadges();
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: "100vh",
        paddingLeft: 4,
        paddingRight: 4,
        justifyContent: "center",
      }}
    >
      {!loading && (
        <ModalNextToTheApp open={open} onClose={() => setOpne(false)} />
      )}
      <ModalUnlockBadge
        listBadges={listUnlokBades}
        setShowModal={setBadgeUnlock}
        showModal={badgeUnlock}
      />
      <Box width={"80%"}>
        <Loading loading={loading} />
        {/* <Box sx={{ display: "flex", alignItems: "center" }}>
          <WorkspacePremiumIcon sx={{ mr: 1 }} />
          <Typography variant="h4">Logros</Typography>
        </Box> */}
        <Container
          maxWidth="md"
          sx={{
            py: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "calc(100vh - 64px)",
          }}
        >
          <Box
            sx={{
              mb: 8,
              display: "flex",
              width: "90%",
              justifyContent: "space-between",
            }}
          >
            <Box
              component="img"
              src={RunnerWoman}
              alt="Runner"
              sx={{ width: 100, height: 150 }}
            />
            <Box
              component="img"
              src={StartBadges}
              alt="Start Badges"
              sx={{ width: 100, height: 100 }}
            />
          </Box>

          <Box
            sx={{
              width: "90%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 15,
            }}
          >
            {groupedAchievements.map((group, rowIndex) => {
              if ((rowIndex + 1) % 2 !== 0) {
                group.reverse();
              }

              return (
                <Box
                  key={rowIndex}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {group.map((achievement, index) => (
                    <StyledCard
                      key={index}
                      sx={{
                        borderColor: achievement.blocked
                          ? "#e7ef7d"
                          : theme.palette.grey[500],

                        position: "relative",
                        ...((rowIndex + 1) % 2 === 0
                          ? index + 1 === 1
                            ? { top: -100 }
                            : index + 1 === 2
                              ? { top: -50 }
                              : { top: 0 }
                          : index + 1 === 1
                            ? { top: 0 }
                            : index + 1 === 2
                              ? { top: -50 }
                              : { top: -100 }),
                      }}
                      onClick={() => {
                        setSelectedBadge(achievement);
                        setShowModal(true);
                      }}
                    >
                      <IconButton
                        sx={{
                          color: achievement.blocked
                            ? "#e7ef7d"
                            : theme.palette.grey[500],
                        }}
                      >
                        <WorkspacePremiumIcon fontSize="large" />
                      </IconButton>
                    </StyledCard>
                  ))}
                </Box>
              );
            })}
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              mt: 8,
            }}
          >
            <Box
              component="img"
              src={FinishBadges}
              alt="Finish Badges"
              sx={{ width: 150, height: 150 }}
            />
          </Box>
        </Container>
      </Box>
      <ModalBadgeOfUser
        showModal={showModal}
        setShowModal={setShowModal}
        badge={selectedBadge}
      />
    </Box>
  );
};

export default BadgeScreen;
